import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "modal fade show",
  id: "confirmDialog",
  tabindex: "-1",
  "aria-labelledby": "confirmDialogTitle",
  "aria-modal": "true",
  role: "dialog",
  style: {"display":"block","padding-left":"0px"}
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "modal-footer" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "modal-backdrop fade show" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.title), 1),
            (_ctx.enableX)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn-close",
                  "data-bs-dismiss": "modal",
                  "aria-label": "Close",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$.emit('cancel')))
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", null, _toDisplayString(_ctx.text), 1),
            _renderSlot(_ctx.$slots, "default")
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_ctx.enableCancel)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-secondary",
                  "data-bs-dismiss": "modal",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$.emit('cancel')))
                }, _toDisplayString(_ctx.cancelBtn), 1))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$.emit('ok')))
            }, _toDisplayString(_ctx.okBtn), 1)
          ])
        ])
      ])
    ]),
    _hoisted_8
  ], 64))
}